import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';
import { Currencies } from 'shared/types';

type ExchangeFormTextFieldProps = {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  readOnly?: boolean;
  defaultValue?: string;
  selectedCurrency?: Currencies | string;
  isNewProduct: boolean;
};

export function ExchangeFormTextField({
  name,
  readOnly = false,
  defaultValue,
  selectedCurrency,
  isNewProduct,
}: ExchangeFormTextFieldProps) {
  const { field } = useController({ name });
  const { setValue } = useFormContext();

  useEffect(() => {
    if (selectedCurrency) {
      setValue(name, defaultValue);
    } else if (isNewProduct) {
      setValue(name, '');
    }
  }, [setValue, defaultValue, selectedCurrency, name, isNewProduct]);

  return (
    <TextField
      id={name}
      label='Exchange Rate'
      value={field.value}
      variant='outlined'
      disabled
      fullWidth
      InputProps={{
        readOnly,
      }}
    />
  );
}
